interface FormatOptions {
    locale?: string;
    toFixed?: number;
    separator?: string;
    decimal?: string;
}

export function FormatNumber(x: number, options: FormatOptions = {}): string {
    let e0 = 1;
    let e1 = 1000;

    let str = "";

    const separator = options.separator || ".";
    const decimal = options.decimal || ",";

    const [n, d] = x
        .toFixed(options.toFixed || 2)
        .split(".")
        .map((y) => parseInt(y, 10));
    while (n / e0 >= 1000) {

        str = "" + headingZeros(Math.floor(n / e0) % e1) + (str !== "" ? separator + str : "");

        e0 *= 1000;
        e1 *= 1000;
    }

    return (Math.floor(n / e0) % e1)
        + (str !== "" ? separator + str : "")
        + (d > 0 ? decimal + d : "");
}

export function headingZeros(x: number, numberOfZeros = 3): string {
    return "0".repeat(Math.max(numberOfZeros - Math.log10(x + 1), 0)) + (x || "");
}

export function FormatLocaleNumber(
    x: number,
    options: FormatOptions = {},
) {
    // @ts-ignore
    const locale = options.locale || Cookies.get("org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE");
    switch (locale) {
        case "en-GB" :
        case "en-US" : {
            return FormatNumber(x, {separator: ",", decimal: ".", toFixed: options.toFixed});
        }
        default: {
            return FormatNumber(x, options);
        }
    }
}
